import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, Field, FieldArray, formValueSelector, reduxForm, reset } from 'redux-form';
import {
  resetFiltersAndSorting,
  showFormatedDate, showNormalizedRate, showWarningMessage,
} from '../../../../actions/utilAction';
import {
  normalizeDecimal,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderTextField,
} from '../../../../components/reduxFields';
import { CommonButton, SubmitButtonDisabled } from '../../../../components/buttons';
import {
  getAllClaimsWithServiceLinesForPayer,
  getMasterData, getPatient,
  getPatientGuarantor, submitApplyPayments,
} from './actions/ManageClaimActions';
import moment from 'moment';
import SortingCustom from '../../../../components/SortingCustom';
import FilterForm from './payment-details_filterForm';


const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};


// function containsKeyWithNonEmptyArray(obj, key) {
//   if (typeof obj !== 'object' || obj === null) {
//     return false;
//   }


//   if (key in obj && Array.isArray(obj[key]) && obj[key].length > 0) {
//     return true;
//   }

//   if (Array.isArray(obj)) {
//     for (let item of obj) {
//       if (containsKeyWithNonEmptyArray(item, key)) {
//         return true;
//       }
//     }
//   } else {
//     for (let property in obj) {
//       if (containsKeyWithNonEmptyArray(obj[property], key)) {
//         return true;
//       }
//     }
//   }

//   return false;
// }

function containsKeyWithNonEmptyArrayAndMinKeys(obj, key, minKeys) {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }


  if (key in obj && Array.isArray(obj[key]) && obj[key].length > 0) {
    for (let item of obj[key]) {
      if (typeof item === 'object' && item !== null && Object.keys(item).length >= minKeys) {
        return true;
      }
    }
  }


  if (Array.isArray(obj)) {
    for (let item of obj) {
      if (containsKeyWithNonEmptyArrayAndMinKeys(item, key, minKeys)) {
        return true;
      }
    }
  } else {
    for (let property in obj) {
      if (containsKeyWithNonEmptyArrayAndMinKeys(obj[property], key, minKeys)) {
        return true;
      }
    }
  }

  return false;
}



const validateFilters = (values) => {
  const errors = {};

  if (!values.Source) {
    if (!Number.isInteger(values.Source)) {
      errors.Source = 'Please select payment source name';
    }
  }
  if (!values.PatientId) {
    if (!Number.isInteger(values.PatientId)) {
      errors.PatientId = 'Please select patient';
    }
  }
  if (!values.DescriptionTypeId) {
    if (!Number.isInteger(values.DescriptionTypeId)) {
      errors.DescriptionTypeId = 'Please select payment description';
    }
  }
  if (!values.PayerId) {
    if (!Number.isInteger(values.PayerId)) {
      errors.PayerId = 'Please select insurance company.';
    }
  }
  if (!values.PaymentTypeId) {
    if (!Number.isInteger(values.PaymentTypeId)) {
      errors.PaymentTypeId = 'Please select payment type.';
    }
  }

  if (!values.TotalCheckAmount) {
    errors.TotalCheckAmount = 'Please enter total check amount.';
  } 
  // else if (values.TotalCheckAmount < values.Amount) {
  //   errors.TotalCheckAmount = 'Total check amount must great than the applied amount.';
  // }
  
  // if (!values.FromDate) {
  //   errors.FromDate = 'Please enter Claim Start Date';
  // }
  // if (!values.ToDate) {
  //   errors.ToDate = 'Please enter Claim End Date';
  // }

  // if (!values.CustomReferenceNumber) {
  //   errors.CustomReferenceNumber = 'Please enter reference number.';
  // }

  // if (!values.Source) {
  //   errors.Source = 'Please enter source';
  // }

  // if (!values.Amount) {
  //   errors.Amount = 'Please enter amount.';
  // }
  // if (!values.PaymentDate) {
  //   errors.PaymentDate = 'Please select payment date.';
  // }

  return errors;
};

class PaymentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Id: null,
      InnerId: null,
      PayerId: null,
      PaymentTypeId: null,
      ActionName: '',
      PaymentDate: new Date(),
      DepositDate: '',
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      totalPayment: 0,
      totalAmount: 0,
      sourceName: null,
      modeName: null,
      patientId: null,
      tags: null,
      masterPaymentDescription: [],
      masterPaymentTypes: [],
      isActionChecked: false,
      partialPayment: [],
      isExcludeTag: false,
      masterTagsAll: [],
      IsAmountMatched: false,
      isAdjustmentExist:false
    };
    this.filter = {
      sort_Column: 'claimId',
      sort_Order: 'desc',
      searchText: '',
    };
    this.handleSearchPaymentDetails = this.handleSearchPaymentDetails.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onFilterFormAmountChange = this.onFilterFormAmountChange.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.onSubmitPaymentDetail = this.onSubmitPaymentDetail.bind(this);
    this.isFullPayment = this.isFullPayment.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.calculateTotalClaimsAmount = this.calculateTotalClaimsAmount.bind(this);
    this.calculateTotalServiceLinesAmount = this.calculateTotalServiceLinesAmount.bind(this);
    this.onChangePaymentAmount = this.onChangePaymentAmount.bind(this);
    this.checkAllForFullPayment = this.checkAllForFullPayment.bind(this);
    // this.checkAllForMarkSettled = this.checkAllForMarkSettled.bind(this);
    //this.checkAllForAction = this.checkAllForAction.bind(this);
    this.isExcludeTagHandler = this.isExcludeTagHandler.bind(this);
    this.onAdjustmentChange = this.onAdjustmentChange.bind(this);
  }
  loadData(page_number) {
    let fromDate = this.state.FromDate,
      toDate = this.state.ToDate;
    let searchObj = {
      PayerIds: this.props.PayerIds || null,
      PatientIds: this.props.PatientIds || null,
      patientTags: this.props.patientTags || null,
      isExcludeTag: this.state.isExcludeTag ? true : false,
      fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : new Date(new Date().setDate(new Date().getDate() - 7)),
      toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : new Date(),
      currentLocationId: this.props.currentLocationId || null,
      claimBalanceStatus: this.state.ClaimPaymentStatus || null,
      sortColumn: this.filter.sort_Column ? this.filter.sort_Column : 'claimid',
      sortOrder: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
    };
    this.props.getAllClaimsWithServiceLinesForPayer(searchObj);
    // console.log('currentLocationId....', this.props.currentLocationId);

  }
  componentWillMount() {
    let masterData = { 'masterdata': 'MASTERINSURANCECOMPANY,MASTERPAYMENTTYPE,MASTERTAGSFORPATIENT,MASTERPAYMENTDESCRIPTION,MASTERADJUSTMENTGROUPCODE,CLAIMPAYMENTSTATUS' };
    this.props.getMasterData(masterData);
    let searchObj = {
      // locationIds: this.props.currentLocationId || '',
      locationIds: '0',
      isActiveCheckRequired: 'NO',
    };
    this.props.getPatient(searchObj);
    // this.props.getPatientGuarantor(patientId);
    // this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.savedApplyPayments && nextProps.savedApplyPayments !== this.props.savedApplyPayments) {
      this.handleReset();
      //this.loadData();
    }
    if (nextProps.claimsWithServiceLinesForPayerDetails && nextProps.claimsWithServiceLinesForPayerDetails !== this.props.claimsWithServiceLinesForPayerDetails) {
            
      (nextProps.claimsWithServiceLinesForPayerDetails || []).forEach((claimsData, claimIndex) => {
        this.props.dispatch(change('PaymentDetailForm', `Claims[${claimIndex}].claimPaymentStatusId`, claimsData.claimPaymentStatusId || null));

          let servicelineBalance = 0.0;
          claimsData.claimServiceLines && claimsData.claimServiceLines !== undefined && claimsData.claimServiceLines.forEach((obj, index) => {
            let fullPaymentCheck = `Claims[${claimIndex}].CheckFullPayment`,
              amountTextField = `Claims[${claimIndex}].totalPaymentAmount`,
              fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${index}].paymentAmount`,
              servicelineBalanceAmount = showNormalizedRate(obj.balance);
              servicelineBalance = parseFloat(servicelineBalance) + parseFloat(servicelineBalanceAmount);
              // console.log('totalAmount....', totalAmount);

              let KeyName = `Claim${claimsData.claimId}`;

              let dFullPaymentCheck = false;
              let dAmountTextField = null;
              if(this.state.claimState && this.state.claimState[KeyName] && this.state.claimState[KeyName].data){
                let data = this.state.claimState[KeyName].data;
                if(data.fullPaymentCheck){
                  dFullPaymentCheck = data.fullPaymentCheck;
                }
                if(data.amountTextField){
                  dAmountTextField = data.amountTextField;
                }
              }

              this.props.dispatch(change('PaymentDetailForm', fullPaymentCheck, dFullPaymentCheck));
              this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, null));
              this.props.dispatch(change('PaymentDetailForm', 'totalAmount', null));
              this.props.dispatch(change('PaymentDetailForm', 'ChkAllFullPayment',this.state.ChkAllFullPayment? this.state.ChkAllFullPayment:false));     
              this.props.dispatch(change('PaymentDetailForm', amountTextField, dAmountTextField));

              
              if( this.state.claimState && this.state.claimState[KeyName] && this.state.claimState[KeyName].claimServiceLines && this.state.claimState[KeyName].claimServiceLines.length){
                let claimState = this.state.claimState;
                let claimServicesLines = claimState[KeyName].claimServiceLines;
                claimServicesLines.forEach((claimServicesLine,i)=>{
                  let fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${i}].paymentAmount`;
                  this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt,claimServicesLine.fieldServiceTotalAmt));
                  // this.props.dispatch(change('PaymentDetailForm', amountTextField,claimServicesLine.fieldServiceTotalAmt));
                })

              } 
          });
          this.setState({ totalAmount: parseFloat(this.state.totalAmount || 0).toFixed(2) },()=>{
            this.props.dispatch(change('PaymentDetailForm', 'totalAmount', parseFloat(this.state.totalAmount || 0).toFixed(2)));
            this.props.dispatch(change('PaymentDetailForm', 'ChkAllFullPayment', this.state.ChkAllFullPayment? this.state.ChkAllFullPayment:false));
          });
      });
    }
  }
  handleSearchPaymentDetails(e) {
    // event.preventDefault();
    //   if (!(this.state.FromDate && this.state.ToDate)) {
    //     return false;
    //   }
    this.setState({      
      totalAmount: 0,
      IsAmountMatched: false,
      claimState:{},
      ChkAllFullPayment:false
    }, () => {
      let claimsArray = this.props.claimsWithServiceLinesForPayerDetails;
      if (claimsArray) {
        let totalAmount = 0;
        claimsArray.forEach((claimsData, claimIndex) => {
          let servicelineBalance = 0.0;
          claimsData.claimServiceLines && claimsData.claimServiceLines !== undefined && claimsData.claimServiceLines.forEach((obj, index) => {
            let fullPaymentCheck = `Claims[${claimIndex}].CheckFullPayment`,
              amountTextField = `Claims[${claimIndex}].totalPaymentAmount`,
              fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${index}].paymentAmount`,
              servicelineBalanceAmount = showNormalizedRate(obj.balance);
              servicelineBalance = parseFloat(servicelineBalance) + parseFloat(servicelineBalanceAmount);
              // console.log('totalAmount....', totalAmount);
              totalAmount = 0;
              this.props.dispatch(change('PaymentDetailForm', fullPaymentCheck, false));
              this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, null));
              this.props.dispatch(change('PaymentDetailForm', 'totalAmount', null));
              this.props.dispatch(change('PaymentDetailForm', 'ChkAllFullPayment', false));     
              this.props.dispatch(change('PaymentDetailForm', amountTextField, null));
          });
        });
        //this.setState({ totalAmount: totalAmount });

        this.setState({ totalAmount: parseFloat(totalAmount || 0).toFixed(2) },()=>{
          if(parseFloat(this.props.Amount || 0).toFixed(2) != parseFloat(totalAmount || 0).toFixed(2)) {
            this.setState({ IsAmountMatched: false});
          }else if(!this.props.Amount || (!parseFloat(this.props.Amount) > 0 && !this.state.isAdjustmentExist)){
            this.setState({ IsAmountMatched: false});
          }
          else {
            this.setState({ IsAmountMatched: true});
          }
        });     
      }
      this.loadData();
    });
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }


  onAdjustmentChange(){
    let flag = false;
    if(this.props.selectorPaymentDetailForm){
      flag = containsKeyWithNonEmptyArrayAndMinKeys(this.props.selectorPaymentDetailForm,"claimServiceLineAdjustment",3);
    }
    this.setState({
      isAdjustmentExist: flag
    })
  }

  onFilterFormAmountChange(input, value) {
    let totalAmount = this.state.totalAmount;
    if(totalAmount && parseFloat(totalAmount) > 0 && parseFloat(value) > 0){
      let amount = parseFloat(value || 0);
      this.setState({ IsAmountMatched: parseFloat(amount || 0).toFixed(2) === parseFloat(totalAmount || 0).toFixed(2)});
    } else{
      this.setState({IsAmountMatched:false});
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadData();
    }
  }
  // checkAllForAction(e) {

  //   // console.log('input.target.checked.........', e.target.checked);
  //   let claimsData = this.props.claimsWithServiceLinesForPayerDetails;

  //   claimsData.forEach((obj, claimIndex) => {
  //     let actionCheck = `Claims[${claimIndex}].Check`;
  //     if (e.target.checked) {
  //       this.setState({
  //         isActionChecked: true,
  //       });
  //       // console.log('actionCheck........', actionCheck);
  //       this.props.dispatch(change('PaymentDetailForm', actionCheck, true));
  //     } else {
  //       this.setState({
  //         isActionChecked: false,
  //       });
  //       // console.log('actionUnCheck........', actionCheck);
  //       this.props.dispatch(change('PaymentDetailForm', actionCheck, false));
  //     }
  //   });
  // }
  checkAllForFullPayment(input) {
    let isFullPaymentChecked = input.target.checked,
      claimsArray = this.props.claimsWithServiceLinesForPayerDetails;

    let claimDataForComponentState = {};
      
    if (claimsArray) {
      let totalAmount = 0;
      claimsArray.forEach((claimsData, claimIndex) => {

        
        let mykey = `Claim${claimsData.claimId}`;
        let dclaimServiceLine = [];

        let servicelineBalance = 0.0;
        claimsData.claimServiceLines && claimsData.claimServiceLines !== undefined && claimsData.claimServiceLines.forEach((obj, index) => {
          let fullPaymentCheck = `Claims[${claimIndex}].CheckFullPayment`,
            amountTextField = `Claims[${claimIndex}].totalPaymentAmount`,
            fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${index}].paymentAmount`,
            servicelineBalanceAmount = showNormalizedRate(obj.balance);
            servicelineBalance = parseFloat(servicelineBalance) + parseFloat(servicelineBalanceAmount);
            // console.log('totalAmount....', totalAmount);
          if (isFullPaymentChecked) {
            totalAmount = parseFloat(totalAmount) + parseFloat(servicelineBalanceAmount);
            this.props.dispatch(change('PaymentDetailForm', fullPaymentCheck, true));
            this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, servicelineBalanceAmount));
            this.props.dispatch(change('PaymentDetailForm', 'totalAmount', parseFloat(showNormalizedRate(totalAmount || 0)).toFixed(2)));
            this.props.dispatch(change('PaymentDetailForm', amountTextField, showNormalizedRate(servicelineBalance || 0)));
            
            dclaimServiceLine.push({
              fieldServiceTotalAmt: servicelineBalanceAmount,
              amountTextField: servicelineBalanceAmount
            });

            claimDataForComponentState[mykey] = {
                claimId:claimsData.claimId,
                claimServiceLines:dclaimServiceLine,
                data:{
                  amountTextField: showNormalizedRate(servicelineBalance || 0),
                  fullPaymentCheck: isFullPaymentChecked
                }
              };
            // this._setClaimDataInState(claimsData.claimId,showNormalizedRate(servicelineBalance || 0),true);
          } else {
            totalAmount = 0;
            this.props.dispatch(change('PaymentDetailForm', fullPaymentCheck, false));
            this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, null));
            this.props.dispatch(change('PaymentDetailForm', 'totalAmount', null));
            this.props.dispatch(change('PaymentDetailForm', amountTextField, null));
            
            dclaimServiceLine.push({
              fieldServiceTotalAmt: null,
              amountTextField: null
            });

            claimDataForComponentState[mykey] = {
                claimId:claimsData.claimId,
                claimServiceLines:dclaimServiceLine,
                data:{
                  amountTextField: null,
                  fullPaymentCheck: isFullPaymentChecked
                }
              };
            // this._setClaimDataInState(claimsData.claimId,null,false);
          }
        });
      });

      this.setState({claimState:claimDataForComponentState});

      //this.setState({ totalAmount: totalAmount });

      this.setState({ totalAmount: parseFloat(totalAmount || 0).toFixed(2) },()=>{
        if(parseFloat(this.props.Amount || 0).toFixed(2) != parseFloat(totalAmount || 0).toFixed(2) ) {
          this.setState({ IsAmountMatched: false});
        }else if(!this.props.Amount || (!parseFloat(this.props.Amount) > 0 && !this.state.isAdjustmentExist)){
          this.setState({ IsAmountMatched: false});
        }
        else {
          this.setState({ IsAmountMatched: true});
        }
      });
      
    }
    this.setState({ChkAllFullPayment:isFullPaymentChecked});
  }
  // checkAllForMarkSettled(input) {
  //   let claimsData = this.props.claimsWithServiceLinesForPayerDetails;
  //   claimsData.forEach((obj, claimIndex) => {
  //     let markSettledCheck = `Claims[${claimIndex}].CheckMarkSettled`;
  //     if (input.target.checked) {
  //       // console.log('markSettledCheck........', markSettledCheck);
  //       this.props.dispatch(change('PaymentDetailForm', markSettledCheck, true));
  //     } else {
  //       // console.log('markSettledCheck........', markSettledCheck);
  //       this.props.dispatch(change('PaymentDetailForm', markSettledCheck, false));
  //     }
  //   });
  // }

  // claimsData.forEach((obj, claimIndex) => {
  //   let fullPaymentCheck = `Claims[${claimIndex}].CheckFullPayment`;
  //   if (input.target.checked) {
  //     console.log('fullPaymentCheck........', fullPaymentCheck);
  //     this.props.dispatch(change('PaymentDetailForm', fullPaymentCheck, true));
  //   } else {
  //     console.log('actionUnCheck........', fullPaymentCheck);
  //     this.props.dispatch(change('PaymentDetailForm', fullPaymentCheck, false));
  //   }
  // });

  handleReset = () => {
    this.props.dispatch(reset('PaymentDetailForm'));
    // this.props.dispatch(change('PaymentDetailForm', 'PayerIds', null));
    // this.props.dispatch(change('PaymentDetailForm', 'PatientIds', null));
    // this.props.dispatch(change('PaymentDetailForm', 'patientTags', null));
    // this.props.dispatch(change('PaymentDetailForm', 'FromDate', null));
    // this.props.dispatch(change('PaymentDetailForm', 'ToDate', null));
    resetFiltersAndSorting(this.filter, 'claimId', true);
    this.setState({
      PayerIds: null,
      PatientIds: null,
      PaymentDate: new Date(),
      DepositDate: '',
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      patientTags: null,
      ClaimPaymentStatus: null,
      Id: null,
      InnerId: null,
      PayerId: null,
      PaymentTypeId: null,
      ActionName: '',    
      totalPayment: 0,
      totalAmount: 0,
      sourceName: null,
      modeName: null,
      patientId: null,
      tags: null,
      masterPaymentDescription: [],
      masterPaymentTypes: [],
      isActionChecked: false,
      partialPayment: [],
      isExcludeTag: false,
      masterTagsAll: [],
      IsAmountMatched: false,
    }, () => {
      this.loadData();
    });
  };
  handleNewRequestMultiSelect(input, selectedValues) {
    input.onChange(selectedValues);
    if (input.name === 'PatientIds') {
      this.setState({
        PatientIds: selectedValues.label
      });
    }
    else if (input.name === 'patientTags') {
      this.setState({
        patientTags: selectedValues.label,
        masterTagsAll: selectedValues
      }, () => {
        if( this.state.masterTagsAll.length === 0) {
          this.props.dispatch(reset('PaymentDetailForm',"ExcludeTag", false))
        }
      });
    }
    else if (input.name === 'ClaimPaymentStatus') {      
       let IsNoPaymentStatus = false;
       if (selectedValues && selectedValues.length === 1) {
         IsNoPaymentStatus = this.props.masterClaimPaymentStatus.filter((obj) => obj.id === selectedValues[0] && obj.globalCodeValue.toLowerCase() === 'no payment status').length > 0 ? true : false;
       }      
        this.setState({ ClaimPaymentStatus: IsNoPaymentStatus ? '0' :  selectedValues,});
    }    
  }
  handleNewRequest(input, selectedValue) {
    // debugger;
    input.onChange(selectedValue.value);
    if (input.name === 'Source') {
      this.setState({
        sourceName: selectedValue.label || null,
      });
      let paymentTypes = this.props.masterPaymentTypes;
      if ((selectedValue.label || '').toLowerCase() === 'insurance') {
        let filterPaymentTypes = paymentTypes.filter((obj) => obj.associatedEntity.toLowerCase() === 'insurance');
        this.setState({
          masterPaymentTypes: filterPaymentTypes || [],
        });
      } else {
        let filterPaymentTypes = paymentTypes.filter((obj) => obj.associatedEntity.toLowerCase() !== 'insurance');
        this.setState({
          masterPaymentTypes: filterPaymentTypes || [],
        });
      }
      // console.log('this.props.masterPaymentDescription', this.props.masterPaymentDescription);
      let descriptionTypes = this.props.masterPaymentDescription;
      if ((selectedValue.label || '').toLowerCase() === 'insurance') {
        let filterDescriptionTypes = descriptionTypes;
        this.setState({
          masterPaymentDescription: filterDescriptionTypes || [],
        });
      } else {
        let filterDescriptionTypes = descriptionTypes.filter((obj) => !(obj.key.toLowerCase()).includes('adjustment'));
        this.setState({
          masterPaymentDescription: filterDescriptionTypes || [],
        });
      }
    }

    // if (input.name === 'DescriptionTypeId') {
    //   // this.setState({
    //   //   masterPaymentDescription: selectedValue.label || null,
    //   // });
    //   if (this.state.sourceName === 'Insurance') {
    //     let paymentTypes = this.props.masterPaymentTypes;
    //     if ((selectedValue.label || '').toLowerCase() === 'adjustment') {
    //       let filterPaymentTypes = paymentTypes.filter((obj) => (obj.key.toLowerCase()).includes('adjustment'));
    //       this.setState({
    //         masterPaymentTypes: filterPaymentTypes || [],
    //       });
    //     } else {
    //       let filterPaymentTypes = paymentTypes.filter((obj) => !(obj.key.toLowerCase()).includes('adjustment') && obj.associatedEntity.toLowerCase() === 'insurance');
    //       // console.log('filterPaymentTypes', filterPaymentTypes);
    //       this.setState({
    //         masterPaymentTypes: filterPaymentTypes || [],
    //       });
    //     }
    //   }
    // }
    if (input.name === 'DescriptionTypeId') {
      if (this.state.sourceName === 'Insurance') {
        let paymentTypes = this.props.masterPaymentTypes;
        if ((selectedValue.label || '').toLowerCase() === 'adjustment') {
          let filterPaymentTypes = paymentTypes.filter((obj) => (obj.key.toLowerCase()).includes('adjustment') || obj.key.toLowerCase() === 'patient_responsibility');
          this.setState({
            masterPaymentTypes: filterPaymentTypes || [],
          });
        }
        else if ((selectedValue.label || '').toLowerCase() === 'copayment') {
          let filterPaymentTypes = paymentTypes.filter((obj) => obj.key.toLowerCase() === 'cash' || obj.key.toLowerCase() === 'cheque' || obj.key.toLowerCase() === 'credit_card');          
          this.setState({
            masterPaymentTypes: filterPaymentTypes || [],
          });
        }
        else {
          let filterPaymentTypes = paymentTypes.filter((obj) => (obj.key.toLowerCase()).includes('adjustment') || obj.key.toLowerCase() === 'ach'  || obj.key.toLowerCase() === 'cheque_ins' || obj.key.toLowerCase() === 'credit_card_ins' || obj.key.toLowerCase() === 'cheque' || obj.key.toLowerCase() === 'non');
          // console.log('filterPaymentTypes', filterPaymentTypes);
          this.setState({
            masterPaymentTypes: filterPaymentTypes || [],
          });
        }
      }
    }
    if (input.name === 'PaymentTypeId') {
      this.setState({ modeName: selectedValue.label || null });
    }
    if (input.name === 'PayerIds') {
      this.setState({ [input.name]: selectedValue.label || null });
    }
    if (input.name === 'PayerId') {
      this.setState({ [input.name]: selectedValue.value || null });
      this.props.dispatch(change('PaymentDetailForm', 'PayerIds', selectedValue.value));
    }
    if (input.name === 'PatientId') {
      this.setState({ [input.name]: selectedValue.value || null });
      this.props.dispatch(change('PaymentDetailForm', 'PatientIds', [selectedValue.value]));
      this.props.getPatientGuarantor(selectedValue.value);

    }
    if (input.name === 'guardianId') {
      this.setState({ [input.name]: selectedValue.value || null });
    }
  }
  onChangePaymentAmount(e, value, claimId, claimIndex) {    
    let partialPayment = this.state.partialPayment;  
    partialPayment[claimIndex] = value || 0;
    this.setState({partialPayment: partialPayment});

    let paymentAmount = value,
      // totalAmount = 0,
      claimsData = this.props.claimsWithServiceLinesForPayerDetails && this.props.claimsWithServiceLinesForPayerDetails.find((data) => data.claimId === claimId);
    if (claimsData && claimsData.claimServiceLines && claimsData.claimServiceLines !== undefined) {

      // if (paymentAmount) {
      //   this.props.dispatch(change('PaymentDetailForm', 'totalAmount', paymentAmount));
      // } else {
      //   this.props.dispatch(change('PaymentDetailForm', 'totalAmount', null));
      // }
      claimsData.claimServiceLines.forEach((obj, index) => {
        let fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${index}].paymentAmount`;
        this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, null));
      });

      let flag = true;
      claimsData.claimServiceLines.forEach((obj, index) => {
        let fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${index}].paymentAmount`;
        // console.log('fieldServiceTotalAmt ............', fieldServiceTotalAmt);
        if (flag && paymentAmount && paymentAmount <= obj.balance) {
          // console.log('paymentAmount 1............', paymentAmount, obj.balance);
          flag = false;
          // totalAmount = parseFloat(totalAmount) + parseFloat()
          // servicelineBalanceAmount = obj.balance;
          this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, parseFloat(showNormalizedRate(paymentAmount)).toFixed(2)));
        } else if (flag && paymentAmount && paymentAmount > obj.balance) {
          //  console.log('paymentAmount 2............', paymentAmount, obj.balance);
          let pendingBal = paymentAmount - obj.balance;
          obj.balance = paymentAmount - pendingBal;
          paymentAmount = pendingBal;
          // console.log('paymentAmount ............', paymentAmount);
          // servicelineBalanceAmount = paymentAmount - pendingBal;
          this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, parseFloat(showNormalizedRate(obj.balance)).toFixed(2)));
        }
      });

      // if the claim total payment is greater than balance amount...
      let fieldServiceTotalAmt = `Claims[${claimIndex}].totalPaymentAmount`,
        claimTotalBalance = claimsData.balance || 0;
      if (claimTotalBalance) {
        //if (parseFloat(paymentAmount).toFixed(2) > parseFloat(claimTotalBalance).toFixed(2)) {
        if (paymentAmount > claimTotalBalance) {
          this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, claimTotalBalance));
          this.calculateTotalServiceLinesAmount(claimTotalBalance, claimIndex);
          e.preventDefault();
          return false;
        }
      } else {
        this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, claimTotalBalance));
      }
    }
    this.calculateTotalServiceLinesAmount(value, claimIndex);
  }
  onChangeClaimServiceLinesPayment(e, value, claimIndex, serviceIndex) {
    let fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${serviceIndex}].paymentAmount`,
      totalServiceAmt = value,
      servicelineTotalAmount = (this.props.claimsWithServiceLinesForPayerDetails[claimIndex] &&  this.props.claimsWithServiceLinesForPayerDetails[claimIndex].claimServiceLines[serviceIndex] && this.props.claimsWithServiceLinesForPayerDetails[claimIndex].claimServiceLines[serviceIndex].balance ? this.props.claimsWithServiceLinesForPayerDetails[claimIndex].claimServiceLines[serviceIndex].balance : 0);
    if (servicelineTotalAmount) {
      //if (parseFloat(totalServiceAmt).toFixed(2) > parseFloat(servicelineTotalAmount).toFixed(2)) {
      if (totalServiceAmt > servicelineTotalAmount) {
        this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, servicelineTotalAmount));
        this.calculateTotalServiceLinesAmount(servicelineTotalAmount, claimIndex, serviceIndex);
        e.preventDefault();
        return false;
      }
    } else {
      this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, servicelineTotalAmount));
    }
    this.calculateTotalServiceLinesAmount(value, claimIndex, serviceIndex);
  }

  calculateTotalClaimsAmount() {
    // let totalAmount = 0;
    // (this.props.selectorClaimsForm || []).forEach((Obj, Index) => {
    //   let payment = ((Obj && Obj.totalPaymentAmount) || 0);
    //   totalAmount = parseFloat(totalAmount) + parseFloat(payment);
    // });
    // this.props.dispatch(change('PaymentDetailForm', 'totalAmount', parseFloat(totalAmount || 0)));
  }

  calculateTotalServiceLinesAmount(value, claimIndex, serviceIndex) {
    let totalAmount = parseFloat(value).toFixed(2) || 0;
    // console.log('this.props.selectorPaymentDetailForm.............', this.props.selectorPaymentDetailForm)
    (this.props.selectorPaymentDetailForm || []).forEach((Obj, index) => {
      if ((serviceIndex >= 0) || (!(serviceIndex >= 0) && claimIndex !== index)) {
        Obj && Obj.claimServiceLines && Obj.claimServiceLines !== undefined && Array.isArray(Obj.claimServiceLines) && Obj.claimServiceLines.length && Obj.claimServiceLines.forEach((serviceObj, sIndex) => {
          if (!(serviceIndex >= 0) || (claimIndex !== index || serviceIndex !== sIndex)) {
            let payment = ((serviceObj && serviceObj.paymentAmount) || 0);
            totalAmount = parseFloat(parseFloat(totalAmount) + parseFloat(payment)).toFixed(2);
          }
        });
      }
    });
    this.setState({ totalAmount: parseFloat(totalAmount || 0).toFixed(2) },()=>{
      if(parseFloat(this.props.Amount || 0).toFixed(2) != parseFloat(totalAmount || 0).toFixed(2)) {
        this.setState({ IsAmountMatched: false});
      }else if(!this.props.Amount || (!parseFloat(this.props.Amount) > 0 && !this.state.isAdjustmentExist)){
        this.setState({ IsAmountMatched: false});
      }
      else {
        this.setState({ IsAmountMatched: true});
      }
    });
    this.props.dispatch(change('PaymentDetailForm', 'totalAmount', parseFloat(totalAmount || 0).toFixed(2)));
  }

  _setClaimDataInState(claimId,amountTextField,fullPaymentCheck,claimServiceLines){
    const newClaim = { claimId, data: {amountTextField, fullPaymentCheck },claimServiceLines};
    let mykey = `Claim${claimId}`;
    this.setState({
      claimState: {
        ...this.state.claimState,
        [mykey]: newClaim
      }
    });
  }

  checkClaimServiceLinesPayment() {
    let totalPayment = 0;
    // debugger;    
    this.props.selectorPaymentDetailForm.forEach((claimObj, cIndex) => {
      claimObj.claimServiceLines && claimObj.claimServiceLines !== undefined && claimObj.claimServiceLines.forEach((serviceObj, sIndex) => {
        let payment = (serviceObj.paymentAmount || 0);
        totalPayment = parseFloat(totalPayment) + parseFloat(payment);
        // console.log('totalPayment', totalPayment);
      });
    });   
    if (this.props.Amount) {
      if (parseFloat(this.props.Amount).toFixed(2) !== parseFloat(totalPayment).toFixed(2)) {
        showWarningMessage('Total claims payment should be equal to the apply payment amount.');
         return false;
      } else {
        return true;
      }
    } else if (totalPayment > 0) {
      showWarningMessage('Please enter amount first');
      return false;
    }
  }
  isFullPayment(input, claimId, claimIndex) {
    let isFullPaymentChecked = input.target.checked,
      totalAmount = this.state.totalAmount,
      totalAmt = 0;      
    // console.log('CheckFullPayment....', this.props);  
    let claimsData = this.props.claimsWithServiceLinesForPayerDetails.find((data) => data.claimId === claimId);
    if (claimsData && claimsData.claimServiceLines && claimsData.claimServiceLines !== undefined ) {

      let dClaimServiceLinesData = [];
      
      claimsData.claimServiceLines.forEach((obj, index) => {
        let fieldServiceTotalAmt = `data.claims[${claimIndex}].claimServiceLines[${index}].paymentAmount`,
        amountTextField = `Claims[${claimIndex}].totalPaymentAmount`,
        servicelineBalanceAmount = showNormalizedRate(obj.balance);
        //  console.log('totalAmount....', totalAmount);
        if (isFullPaymentChecked) {
          totalAmount = parseFloat(totalAmount) + parseFloat(servicelineBalanceAmount);
          totalAmt = parseFloat(totalAmt) + parseFloat(servicelineBalanceAmount);
          this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, servicelineBalanceAmount));
          this.props.dispatch(change('PaymentDetailForm', amountTextField, parseFloat(totalAmt || 0).toFixed(2)));
          dClaimServiceLinesData.push({fieldServiceTotalAmt: servicelineBalanceAmount, amountTextField: parseFloat(totalAmt || 0).toFixed(2)});
        } else {
          totalAmount = parseFloat(totalAmount) - parseFloat(servicelineBalanceAmount);
          this.props.dispatch(change('PaymentDetailForm', fieldServiceTotalAmt, null));
          this.props.dispatch(change('PaymentDetailForm', amountTextField, null));
          dClaimServiceLinesData.push({fieldServiceTotalAmt: null, amountTextField: null});
          // this.props.dispatch(change('PaymentDetailForm', 'totalAmount', null));
        }
      });
      
      ////////////////////////////////////
      this._setClaimDataInState(claimId,isFullPaymentChecked?claimsData.balance:null,isFullPaymentChecked,dClaimServiceLinesData);
      ///////////////////////////////////////
      

      totalAmount = totalAmount - parseFloat(this.state.partialPayment[claimIndex] || 0);
      
      let partialPayment = this.state.partialPayment;  
      partialPayment[claimIndex] = 0;  

      this.setState({partialPayment: partialPayment, totalAmount:  parseFloat(totalAmount || 0).toFixed(2)},()=>{
        if(parseFloat(this.props.Amount || 0).toFixed(2) != parseFloat(totalAmount || 0).toFixed(2)) {
          this.setState({ IsAmountMatched: false});
        }else if(!this.props.Amount || (!parseFloat(this.props.Amount) > 0 && !this.state.isAdjustmentExist)){
          this.setState({ IsAmountMatched: false});
        }
        else {
          this.setState({ IsAmountMatched: true});
        }
      });
      this.props.dispatch(change('PaymentDetailForm', 'totalAmount', parseFloat(totalAmount || 0).toFixed(2)));

      ////////////////
      this.setState({
        totalAmount: parseFloat(totalAmount || 0).toFixed(2)
      })
      //////////
    }
  }
  onSubmitPaymentDetail(formValues) {
    // console.log(formValues);
    let formDataArray = [],
      claimsData = formValues.Claims,
      self = this;
    if (claimsData) {
      claimsData.forEach((Obj, claimIndex) => {
      let serviceLinesArray = formValues.data.claims[claimIndex] && formValues.data.claims[claimIndex].claimServiceLines ? formValues.data.claims[claimIndex].claimServiceLines : [];      
      // console.log('serviceLinesArray......', serviceLinesArray);
      if (serviceLinesArray && serviceLinesArray.length > 0 && ((serviceLinesArray[0].paymentAmount != null && serviceLinesArray[0].paymentAmount > 0) || (serviceLinesArray[0].claimServiceLineAdjustment != null && serviceLinesArray[0].claimServiceLineAdjustment[0].AmountAdjusted > 0))) {
          let claimObj = self.props.claimsWithServiceLinesForPayerDetails[claimIndex];
          // console.log('claimObj......', claimObj);
          if(claimObj) {
            let claimServiceLinePayments = [];
            serviceLinesArray.forEach((obj, index) => {
              // console.log('obj......', obj);
              let serviceCodeObj = claimObj.claimServiceLines[index];
              if (obj.paymentAmount || obj.claimServiceLineAdjustment) {
                claimServiceLinePayments.push({
                  paymentAmount: obj.paymentAmount,
                  claimServiceLineAdjustment: obj.claimServiceLineAdjustment,
                  ...serviceCodeObj,
                });
              }
            });
          
            // claimObj.markSettled = obj.CheckMarkSettled;
            claimObj.claimPaymentStatusId = Obj.claimPaymentStatusId || null;
            claimObj.claimServiceLines = claimServiceLinePayments;
            formDataArray.push(claimObj);
          }
        }
      });
    }
    if (!(formDataArray && formDataArray.length)) {
      return false;
    }

    if (!this.checkClaimServiceLinesPayment()) {
      return false;
    } else {
      let postData = {
        PayerId: this.props.GuarantorId ? null : this.props.PayerId,
        PaymentTypeId: this.props.PaymentTypeId,
        DescriptionTypeId: this.props.DescriptionTypeId,
        CustomReferenceNumber: this.props.CustomReferenceNumber || null,
        GuarantorId: this.props.GuarantorId,
        PatientId: this.props.GuarantorId ? null : this.props.PatientId,
        Amount: this.props.Amount,
        PaymentDate: this.state.PaymentDate ? moment(this.state.PaymentDate).format('YYYY-MM-DD') : null,
        DepositDate: this.state.DepositDate ? moment(this.state.DepositDate).format('YYYY-MM-DD') : null,
        Claims: formDataArray,
        TotalCheckAmount: this.props.TotalCheckAmount || null,
      };
      // console.log('postData values to send...', JSON.stringify(postData));
     this.props.submitApplyPayments(postData);
     //this.handleReset();
    }
  }

  handleExpandRow = (Id) => {
    this.setState({ Id: Id });
    let display = this.refs['expandedClass' + Id].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + Id].style.display = 'table-row';
      this.refs['expClass' + Id].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + Id].style.display = 'none';
      this.refs['expClass' + Id].className = 'classExpand fa fa-ellipsis-h';
    }
  }

  handleExpandInnerRow = (InnerId, patientInsuranceId, claimIndex, serviceIndex) => {

    this.setState({ InnerId: InnerId });
    let display = this.refs['expandedInnerClass' + InnerId].style.display;
    if (display === 'none') {
      if (InnerId) {
        this.props.dispatch(change('PaymentDetailForm',
          `data.claims[${claimIndex}].claimServiceLines[${serviceIndex}].claimServiceLineAdjustment`,
          [{ ServiceLineId: InnerId, patientInsuranceId: patientInsuranceId }]
        ));
      }
      this.refs['expandedInnerClass' + InnerId].style.display = 'table-row';
      this.refs['expInnerClass' + InnerId].className = 'classExpand fa fa-minus';
    } else {
      if (InnerId) {
        this.props.dispatch(change('PaymentDetailForm',
          `data.claims[${claimIndex}].claimServiceLines[${serviceIndex}].claimServiceLineAdjustment`,
          []
        ));
      }
      this.refs['expandedInnerClass' + InnerId].style.display = 'none';
      this.refs['expInnerClass' + InnerId].className = 'classExpand fa fa-ellipsis-h';
    }
  }


  addRow = () => { };
  removeRow = (i) => { };

  renderClaimServiceAdjustments = ({ fields, patientInsuranceId, ServiceLineId }) => {
    this.onAdjustmentChange();

    // console.log(patientInsuranceId, ServiceLineId)
    this.removeRow = (i, e) => {

    };

    this.addRow = (e) => {

    };

    return (
      <tbody>
        {fields.map((Adjustments, adjIndex) =>
          <tr key={adjIndex}>
            <td width="5%">
            </td>
            <td width="10%">
            </td>
            <td width="25%">
              <Field
                onChange={this.onAdjustmentChange}
                name={`${Adjustments}.AmountAdjusted`}
                type="text"
                maxLength="8"
                hintText="Adj. Amount($)"
                component={renderTextField}
                normalize={normalizeDecimal} />
            </td>
            <td width="20%">
              {/* {console.log('masterAdjustmentGroupCode.............', this.props.masterAdjustmentGroupCode)} */}
              <div className="mt-20">
                <Field
                  onChange={this.onAdjustmentChange}
                  name={`${Adjustments}.AdjustmentGroupCode`}
                  label="Adj. Group Code"
                  handleNewRequest={this.handleNewRequest}
                  options={this.props.masterAdjustmentGroupCode || []}
                  component={renderAutoCompleteSingleSelect} />
              </div>
            </td>
            <td width="20%">
              <Field
                onChange={this.onAdjustmentChange}
                name={`${Adjustments}.AdjustmentReasonCode`}
                type="text"
                maxLength="6"
                hintText="Adj. Reason Code"
                component={renderTextField} />
            </td>
            <td width="20%">
              {fields.length === adjIndex + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className="tableless"
                      onClick={(e) => {
                        this.onAdjustmentChange();
                        fields.remove(adjIndex)
                      }}
                      title="Remove Adjustment"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button> : ''}
                  <button className="tableadd"
                    title="Add Adjustment"
                    onClick={(e) => {
                        this.onAdjustmentChange();
                        fields.push({ ServiceLineId: ServiceLineId, patientInsuranceId: patientInsuranceId })
                      }} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>

                </div>
                :
                <button className="tableless"
                  onClick={(e) => fields.remove(adjIndex)}
                  title="Remove Adjustment"
                  type="button">
                  <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                </button>
              }

            </td>
          </tr>
        )}
      </tbody>
    );
  }

  renderInnerData(claimServiceLines, claimIndex, patientInsuranceId) {
    const tableClass3 = classNames({
      'table': true,
      'childtable': true,
      'customtable': false,
    });
    // const tableClass4 = classNames({
    //   'table': true,
    //   'childtable': true,
    // });

    let claimInnerData = claimServiceLines || [];
    return claimInnerData.map((obj, serviceIndex) => {

      return (
        <tbody key={obj.id}>
          <tr>
            <td width="5%"></td>
            <td width="10%">
              <div className="table_custom-check">
                <button onClick={(e) => this.handleExpandInnerRow(obj.id, patientInsuranceId, claimIndex, serviceIndex)} type="button" className="morebtn">
                  <b ref={'expInnerClass' + obj.id} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></b>
                </button>

              </div>
            </td>
            <td width="25%">{obj.serviceCode || '-'}</td>
            <td width="20%">{showNormalizedRate(obj.totalAmount || 0)}</td>
            <td width="20%">{showNormalizedRate(obj.balance || 0)}

            </td>
            <td width="20%">
              <Field
                name={`data.claims[${claimIndex}].claimServiceLines[${serviceIndex}].paymentAmount`}
                type="text"
                maxLength="10"
                hintText={'0.00'}
                // normalize = {normalizeRate}
                onChange={(e, value) => this.onChangeClaimServiceLinesPayment(e, value, claimIndex, serviceIndex)}
                component={renderTextField} />
            </td>

          </tr>
          <tr className="nohover" ref={'expandedInnerClass' + obj.id} style={{ 'display': 'none' }}>

            <td colSpan="6">
              <table className={tableClass3}>
                <FieldArray
                  name={`data.claims[${claimIndex}].claimServiceLines[${serviceIndex}].claimServiceLineAdjustment`}
                  ServiceLineId={obj.id}
                  patientInsuranceId={patientInsuranceId}
                  component={this.renderClaimServiceAdjustments} />
              </table>
            </td>
          </tr>
        </tbody>
      );
    });
  }

  renderData() {
    // console.log('this.props.claimsWithServiceLinesForPayerDetails..............', this.props.claimsWithServiceLinesForPayerDetails);
    const tableClass1 = classNames({
      'table': true,
      'middletable': true,
      'customtable': true,
    });
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    let claimsData = this.props.claimsWithServiceLinesForPayerDetails || [];
    // console.log('claimsData..............', claimsData);
    if (!claimsData.length) {
      return (<tr>
        <td colSpan='9'>
          <div className="familydl text-center no-record">{this.props.loading ? 'Loading, Please wait...' : 'No record found!'}</div>
        </td>
      </tr>);
    }
    return claimsData.map((obj, claimIndex) => {
      // console.log('obj..............', this.props);
      return (
        <tr key={obj.claimId}>
          <td colSpan="9">
            <table className={tableClass1}>
              <tbody>
                <tr>
                  <td width="5%">
                    <div className="table_custom-check">
                      <button onClick={(e) => this.handleExpandRow(obj.claimId)} type="button" className="morebtn">
                        <b ref={'expClass' + obj.claimId} className="classExpand fa fa-minus" aria-hidden="true"></b>
                      </button>

                    </div>
                  </td>
                  <td width="10%">CL{obj.claimId}</td>
                  <td width="15%">{obj.patientName || '-'}</td>
                  <td width="10%">{obj.dos ? showFormatedDate(obj.dos) : '-'}</td>
                  <td width="15%">{showNormalizedRate(obj.totalAmount || 0)}</td>
                  <td width="10%">
                    <Field
                      name={`Claims[${claimIndex}].totalPaymentAmount`}
                      type="text"
                      maxLength="10"
                      hintText={'0.00'}
                      // normalize = {normalizeRate}
                      onChange={(e, value) => this.onChangePaymentAmount(e, value, obj.claimId, claimIndex)}
                      component={renderTextField} />
                  </td>
                  {/* <td width="9%">
                    <Field
                      name={`Claims[${claimIndex}].Check`}
                      component={renderCheckBox}
                      style={stylescss.checkbox}
                    />
                  </td> */}
                  <td width="10%">
                    <Field
                      name={`Claims[${claimIndex}].CheckFullPayment`}
                      component={renderCheckBox}
                      onChange={(input) => this.isFullPayment(input, obj.claimId, claimIndex)}
                      //disabled={!(this.props.selectorClaims && this.props.selectorClaims[claimIndex] && this.props.selectorClaims[claimIndex].Check)}
                      style={stylescss.checkbox}
                    />
                  </td>
                  {/* <td width="9%">
                    <Field
                      name={`Claims[${claimIndex}].CheckMarkSettled`}
                      component={renderCheckBox}
                      disabled={!(this.props.selectorClaims && this.props.selectorClaims[claimIndex] && this.props.selectorClaims[claimIndex].Check)}
                      style={stylescss.checkbox}
                    />
                  </td> */}
                  <td width="25%">
                    <Field
                      name={`Claims[${claimIndex}].claimPaymentStatusId`}
                      hintText="Status"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.masterClaimPaymentStatus}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </td>
                </tr>
                <tr className="nohover" ref={'expandedClass' + obj.claimId} style={{ 'display': 'table-row' }}>
                  <td colSpan="9">
                    <table className={tableClass2}>
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <th width="10%"></th>
                          <th width="25%">Service Code</th>
                          <th width="20%">Total Amount($)</th>
                          <th width="20%">Total Balance($)</th>
                          <th width="20%">Payment($)</th>

                        </tr>
                      </thead>
                      {this.renderInnerData(obj.claimServiceLines, claimIndex, obj.patientInsuranceId)} 
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    });
  }

  isExcludeTagHandler = () => {
    this.setState({
      isExcludeTag: !this.state.isExcludeTag
    });
  }

  render() {

    // console.log('claimsWithServiceLinesForPayerDetails...', this.props);
    const { handleSubmit, claimsWithServiceLinesForPayerDetails } = this.props;
    let recordsCount = claimsWithServiceLinesForPayerDetails.length;

    //let checksCount = this.props.selectorClaims ? this.props.selectorClaims.filter((obj) => obj && obj.Check).length : 0;

    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'customtable': true,
    });
    return (
      <div>
        <h2 className="page_title">Apply Payments</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="panel_title no_margin">
              <h3>Payment Detail</h3><i className="flaticon flaticon-invoice"></i>
            </div>
            <form className="readmin-form custom_form">
              <FilterForm
                masterInsuranceCompanies={this.props.masterInsuranceCompanies}
                masterPaymentDescription={this.state.masterPaymentDescription}
                masterTags={this.props.masterTags}
                masterPaymentTypes={this.state.masterPaymentTypes}
                patientList={this.props.patientList}
                PaymentDate={this.state.PaymentDate}
                DepositDate={this.state.DepositDate}
                FromDate={this.state.FromDate}
                ToDate={this.state.ToDate}
                sourceName={this.state.sourceName}
                modeName={this.state.modeName}
                guarantorList={this.props.guarantorList}
                onDateChange={this.onDateChange}
                onFilterFormAmountChange={this.onFilterFormAmountChange}
                handleNewRequest={this.handleNewRequest}
                handleNewRequestMultiSelect={this.handleNewRequestMultiSelect}
                handleSearchPaymentDetails={this.handleSearchPaymentDetails}
                handleReset={this.handleReset}
                isExcludeTagHandler={this.isExcludeTagHandler}
                isExcludeTag={this.state.isExcludeTag}
                masterTagsAll={this.state.masterTagsAll}
                masterClaimPaymentStatus = {this.props.masterClaimPaymentStatus} />

              <div className="row">
                <div className="col-sm-12">
                  <div className="table-responsive mt-20">
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="5%">
                            <div className="table_custom-check">
                              {/* <Field
                              name='Chkclaim'
                              component={renderCheckBox}
                              style={stylescss.checkbox}
                            /> */}
                              <span>&nbsp;</span>
                            </div>
                          </th>
                          <th width="10%">
                            <SortingCustom noSort={!recordsCount} setSortColumn={this.setSortColumn} columnName='claimId' displayName='Claim ID' />
                          </th>
                          <th width="15%">
                            <SortingCustom noSort={!recordsCount} setSortColumn={this.setSortColumn} columnName='patientName' displayName='Client Name' />
                          </th>
                          <th width="10%">
                            <SortingCustom noSort={!recordsCount} setSortColumn={this.setSortColumn} columnName='dos' displayName='DOS' />
                          </th>
                          <th width="15%">
                            Total Amt($)
                          </th>
                          <th width="10%"></th>
                          {/* <th width="9%">Action
                            <div className="table_custom-check">
                              <Field
                                name='ChkAllAction'
                                component={renderCheckBox}
                                disabled={this.props.claimsWithServiceLinesForPayerDetails.length ? false : true}
                                onChange={(e) => this.checkAllForAction(e)}
                                style={stylescss.checkbox}
                              />
                              <span>&nbsp;</span>
                            </div>
                          </th> */}
                          <th width="10%">Full Paid
                            <div className="table_custom-check">
                              <Field
                                name='ChkAllFullPayment'
                                component={renderCheckBox}
                                //disabled={this.props.claimsWithServiceLinesForPayerDetails.length && this.state.isActionChecked ? false : true}
                                onChange={(e) => this.checkAllForFullPayment(e)}
                                style={stylescss.checkbox}
                              />
                              <span>&nbsp;</span>
                            </div>
                          </th>
                          {/* <th width="9%">Settled
                            <div className="table_custom-check">
                              <Field
                                name='MarkSettled'
                                component={renderCheckBox}
                                disabled={this.props.claimsWithServiceLinesForPayerDetails.length && this.state.isActionChecked ? false : true}
                                onChange={(e) => this.checkAllForMarkSettled(e)}
                                style={stylescss.checkbox}
                              />
                              <span>&nbsp;</span>
                            </div>
                          </th> */}
                          <th width="25%">Payment Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    {/* <PaginatorCustom data={this.props.readyToBillClaims.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} /> */}


                  </div>
                </div>
              </div>
              {recordsCount ?
                <div className="row">
                  <div className="col-sm-12 pt20 btn_rt">
                    {this.props.loading ?
                      <SubmitButtonDisabled label="Submitting" /> :
                      <CommonButton label="Apply Payments" primary={true} 
                      disabled={(this.state.IsAmountMatched || this.state.isAdjustmentExist) ? false : true} 
                      onTouchTap={handleSubmit(this.onSubmitPaymentDetail)} />}
                  </div>
                </div>
                : null}

            </form>
          </div>
        </div>
      </div>
    );
  }
}

const scrollToInvalid = (errors) => {
  if (errors) {
    let errorObject = Object.keys(errors).find((obj) => document.getElementsByName(obj)[0]),
      invalidInput = document.getElementsByName(errorObject)[0];
    let errorInputTop = -1000;
    if (invalidInput) {
      errorInputTop = invalidInput.getBoundingClientRect().top - 100;
    }
    window.scrollTo(0, window.pageYOffset + errorInputTop);
  }
};

PaymentDetail = reduxForm({
  form: 'PaymentDetailForm',
  validate: validateFilters,
  onSubmitFail: (errors) => scrollToInvalid(errors),
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(PaymentDetail);

// const selectorFilterForm = formValueSelector('PaymentDetailFilterForm');
const selectorPaymentDetailForm = formValueSelector('PaymentDetailForm');
function mapStateToProps(state) {
  // console.log('  state.billing.master_data.........',  state.billing.master_data);
  let masterInsuranceCompanies = [], masterPaymentTypes = [], masterTags = [], masterPaymentDescription = [], patients = [], guarantors = [], masterAdjustmentGroupCode = [], masterClaimPaymentStatus = [];
  let claimsWithServiceLinesForPayerDetails = [];
  if (state.billing.master_data && state.billing.master_data.masterPaymentDescription) {
    masterPaymentDescription = state.billing.master_data.masterPaymentDescription;
  }
  if (state.billing.master_data && state.billing.master_data.insuranceCompanies) {
    masterInsuranceCompanies = state.billing.master_data.insuranceCompanies;
  }
  if (state.billing.master_data && state.billing.master_data.adjustmentGroupCodeModel) {
    //masterAdjustmentGroupCode = state.billing.master_data.adjustmentGroupCodeModel;
    masterAdjustmentGroupCode = state.billing.master_data.adjustmentGroupCodeModel.map((obj) => {
      return {
        id: obj.value,
        value: obj.value,
      };
    });
  }
  if (state.billing.master_data && state.billing.master_data.claimPaymentStatus) {
    masterClaimPaymentStatus = state.billing.master_data.claimPaymentStatus;
  }

  if (state.billing.guarantorList && state.billing.guarantorList.data) {
    guarantors = state.billing.guarantorList.data.map((obj) => {
      return {
        id: obj.guardianId,
        value: obj.guarantorName,
      };
    });
  }
  if (state.billing.patientList && state.billing.patientList.data) {
    patients = state.billing.patientList.data.patients;
  }
  if (state.billing.master_data && state.billing.master_data.masterTagsforPatient) {
    masterTags = state.billing.master_data.masterTagsforPatient;
  }
  if (state.billing.master_data && state.billing.master_data.masterPaymentType) {
    masterPaymentTypes = state.billing.master_data.masterPaymentType;
  }
  if (state.billing.claimsWithServiceLinesForPayerDetails) {
    claimsWithServiceLinesForPayerDetails = state.billing.claimsWithServiceLinesForPayerDetails.data.claims;
  }
  return {
    loading: state.billing.loading,
    masterPaymentTypes: masterPaymentTypes || [],
    masterInsuranceCompanies: masterInsuranceCompanies || [],
    masterPaymentDescription: masterPaymentDescription || [],
    masterTags: masterTags || [],
    currentLocationId: state.login.currentLocationId,
    claimsWithServiceLinesForPayerDetails: claimsWithServiceLinesForPayerDetails || [],
    // initialValues: initialValueData,
    savedApplyPayments: state.billing.savedApplyPayments,
    masterAdjustmentGroupCode: masterAdjustmentGroupCode || [],
    masterClaimPaymentStatus: masterClaimPaymentStatus || [],
    patientList: patients,
    guarantorList: guarantors,
    PayerId: selectorPaymentDetailForm(state, 'PayerId'),
    PaymentTypeId: selectorPaymentDetailForm(state, 'PaymentTypeId'),
    DescriptionTypeId: selectorPaymentDetailForm(state, 'DescriptionTypeId'),
    CustomReferenceNumber: selectorPaymentDetailForm(state, 'CustomReferenceNumber') || '',
    PatientId: selectorPaymentDetailForm(state, 'PatientId'),
    Amount: selectorPaymentDetailForm(state, 'Amount'),
    TotalCheckAmount: selectorPaymentDetailForm(state, 'TotalCheckAmount'),
    PaymentDate: selectorPaymentDetailForm(state, 'PaymentDate'),
    DepositDate: selectorPaymentDetailForm(state, 'DepositDate'),
    GuarantorId: selectorPaymentDetailForm(state, 'GuarantorId'),
    selectorPaymentDetailForm: selectorPaymentDetailForm(state, 'data.claims'),
    PayerIds: selectorPaymentDetailForm(state, 'PayerIds'),
    PatientIds: selectorPaymentDetailForm(state, 'PatientIds'),
    patientTags: selectorPaymentDetailForm(state, 'patientTags'),
    ClaimPaymentStatus: selectorPaymentDetailForm(state, 'ClaimPaymentStatus'),
    selectorClaims: selectorPaymentDetailForm(state, 'Claims'),
  };

}
export default connect(mapStateToProps, { getMasterData, submitApplyPayments, getAllClaimsWithServiceLinesForPayer, getPatient, getPatientGuarantor })(PaymentDetail);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/payment-detail.js